import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useAdmin } from '../../context/AdminContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTag, faUtensils } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';
import AdminNotice from '../shared/AdminNotice';

const AddCategoryModal = ({ show, onClose, onCategoryAdded }) => {
  const [name, setName] = useState('');
  const [errors, setErrors] = useState({});
  const { menus } = useAdmin();
  const selectedMenu = menus[0] || null;
  const menuId = selectedMenu?.id || '';

  const validateForm = () => {
    const nextErrors = {};
    if (!name) nextErrors.name = 'Kategori adı boş olamaz.';
    if (!menuId) nextErrors.menuId = 'Menü bulunamadı.';
    return nextErrors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const nextErrors = validateForm();
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    onCategoryAdded({ name, menuId });
    setName('');
    setErrors({});
    onClose();
  };

  return (
    <AdminFormModal
      show={show}
      onClose={onClose}
      title="Yeni Kategori Ekle"
      subtitle="Menü akışını daha okunur hale getirecek yeni bir kategori başlığı oluşturun."
      icon={faPlus}
      notice={
        errors.menuId ? <AdminNotice tone="error" title="Kategori eklenemedi" message={errors.menuId} onDismiss={() => setErrors((current) => ({ ...current, menuId: undefined }))} /> : null
      }
      footer={(
        <>
          <div className="admin-modal-footer-secondary">
            <Button variant="secondary" onClick={onClose} className="modal-cancel-btn">
              İptal
            </Button>
          </div>
          <div className="admin-modal-footer-primary">
            <Button variant="primary" onClick={handleSubmit} className="modal-save-btn">
              <FontAwesomeIcon icon={faPlus} />
              Kategori Ekle
            </Button>
          </div>
        </>
      )}
    >
      <Form onSubmit={handleSubmit} className="admin-form-section">
        <div className="admin-form-block">
          <div className="admin-form-block-title">
            <FontAwesomeIcon icon={faTag} />
            Kategori Bilgisi
          </div>
          <div className="admin-form-grid admin-form-grid-single">
            <div className="admin-modal-field">
              <Form.Label>Kategori Adı</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(event) => setName(event.target.value)}
                className={`form-input ${errors.name ? 'error' : ''}`}
                placeholder="Örn: Ana Yemekler, İçecekler"
                required
              />
              {errors.name ? <div className="error-message">{errors.name}</div> : null}
            </div>
            {selectedMenu ? (
              <div className="admin-modal-field">
                <Form.Label>
                  <FontAwesomeIcon icon={faUtensils} className="form-icon" />
                  Menü
                </Form.Label>
                <Form.Control type="text" value={selectedMenu.name} disabled className="form-input" />
                <div className="admin-modal-helper">Kategori bu menüye eklenecek.</div>
              </div>
            ) : null}
          </div>
        </div>
      </Form>
    </AdminFormModal>
  );
};

export default AddCategoryModal;
